<template lang="pug">
v-row(class="mx-4")
  v-col(cols="8")
    v-file-input(
      @change="onFilePicked"
      v-model="file"
      :rules="rules"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      placeholder="Seleccione un archivo"
      prepend-icon="mdi-file-excel"
      ref="fileExcel"
      label="Listado números de matrícula")
  v-col(cols="4")
    v-btn(
      color="green"
      :loading="loadingExcel"
      :disabled="file === null"
      class="ma-2 white--text"
      @click="sendFile")
      | cargar archivo
      v-icon(
        right
        dark) mdi-cloud-upload
  v-col(class="pt-0" cols="12")
    v-alert(
      v-if="excelError !== ''"
      border="top"
      color="red lighten-2"
      v-html="excelError"
      dark)
    </v-alert>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'VurExcelList',

  components: {
  },

  data: () => ({
    file: null,
    rules: [
      value => !value || value.size < 2000000 || 'File size should be less than 2 MB!',
    ],
  }), 

  computed: {
    ...mapState('vur', ['loadingExcel', 'excelError'],)
  },

  methods: {
    ...mapActions('vur', ['uploadFile']),
    async sendFile() {
      await this.uploadFile({
        file: this.file
      })
      this.file = null;
      this.file = null;
    },
    onFilePicked(e) {
      this.file=e;
    }
  },
};
</script>
  